__turbopack_context__.v({
  "closeBtn": "StudentLoginModal-module-scss-module__eQ1DlW__closeBtn",
  "modal": "StudentLoginModal-module-scss-module__eQ1DlW__modal",
  "modalTitle": "StudentLoginModal-module-scss-module__eQ1DlW__modalTitle",
  "overlay": "StudentLoginModal-module-scss-module__eQ1DlW__overlay",
  "radioCard": "StudentLoginModal-module-scss-module__eQ1DlW__radioCard",
  "radioCardActive": "StudentLoginModal-module-scss-module__eQ1DlW__radioCardActive",
  "radioDot": "StudentLoginModal-module-scss-module__eQ1DlW__radioDot",
  "radioGroup": "StudentLoginModal-module-scss-module__eQ1DlW__radioGroup",
  "radioInput": "StudentLoginModal-module-scss-module__eQ1DlW__radioInput",
  "radioLabel": "StudentLoginModal-module-scss-module__eQ1DlW__radioLabel",
  "submitBtn": "StudentLoginModal-module-scss-module__eQ1DlW__submitBtn",
});
